function addDays(date, days){
  var result = new Date(date)
  result.setDate(result.getDate()+days)
  var dateString = result.toISOString()
  return dateString.substring(0,10)
}

export {addDays}